export default "__VITE_ASSET__dec53d80__"